import { getTokens } from 'core/classes/helpers/StorageHelper'
import WebSocketStore from 'core/classes/services/WebSocketStore'
import { ILandingPartnerFromSearch } from 'partner360/models/landing/ILandingPartnerFromSearch'

interface ILandingSearchPartner {
  ownerId: string
  searchStr: string
  fYear: number
}

export const landingSearchPartner = async ({
  ownerId,
  searchStr,
  fYear,
}: ILandingSearchPartner) => {
  const wsClient = WebSocketStore.get('partner360')
  const [token] = getTokens(ownerId)

  try {
    const res = await wsClient.call<ILandingPartnerFromSearch[]>({
      service: 'landing',
      action: 'searchPartner',
      payload: { searchStr, fYear },
      token: token || undefined,
      withoutTokenRefresh: true,
      isAuth: true,
    })
    return res.data
  } catch (e: any) {
    return null
  }
}
